import { useState } from "react";
import { ChevronDown, ChevronUp, Zap, Stamp, FileCheck2, CalendarDays, Wallet } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import { DELIVERY, TYPES, DOCS, budgetLabel, datesLabel } from "./filters";
import { BudgetPanel, Option } from "./BudgetPanel";

export function FilterIcon({ icon: Icon, color }) {
  return <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full" style={{ background: `${color}1F`, color }}><Icon className="h-5 w-5" strokeWidth={1.9} /></span>;
}
import { DatesPanel } from "./DatesPanel";

const SEGMENTS = [
  { id: "budget", label: "Budget:", color: "#0088FF", icon: Wallet },
  { id: "delivery", label: "Visa delivery:", color: "#34C759", icon: Zap },
  { id: "type", label: "Type:", color: "#5E5CE6", icon: Stamp },
  { id: "docs", label: "Documents:", color: "#F0A030", icon: FileCheck2 },
  { id: "dates", label: "Travel dates:", color: "#C8356A", icon: CalendarDays },
];

export default function FilterBar({ value, onChange }) {
  const [open, setOpen] = useState(null);
  const set = (k, v) => { onChange({ ...value, [k]: v }); setOpen(null); };
  const labels = { delivery: DELIVERY.find((x) => x[0] === value.delivery)[1], type: TYPES.find((x) => x[0] === value.type)[1], docs: DOCS.find((x) => x[0] === value.docs)[1], dates: datesLabel(value.dates), budget: budgetLabel(value.budget) };

  return (
    <div className="no-scrollbar flex w-full items-stretch overflow-x-auto rounded-full border border-separator bg-background shadow-card" data-testid="filter-bar">
      {SEGMENTS.map((s, i) => (
        <Popover key={s.id} open={open === s.id} onOpenChange={(o) => setOpen(o ? s.id : null)}>
          <PopoverTrigger asChild>
            <button type="button" data-testid={`filter-${s.id}`} className={`flex min-w-[190px] flex-1 items-center gap-3 px-5 py-3 text-left transition-colors hover:bg-gray6/70 ${i === 0 ? "rounded-l-full" : ""} ${i === SEGMENTS.length - 1 ? "rounded-r-full" : "border-r border-separator"}`}>
              <FilterIcon icon={s.icon} color={s.color} />
              <span className="min-w-0"><span className="block text-xs text-label2">{s.label}</span><span className="flex items-center gap-1 truncate text-base font-semibold text-foreground" data-testid={`filter-${s.id}-value`}>{labels[s.id]} {open === s.id ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}</span></span>
            </button>
          </PopoverTrigger>
          <PopoverContent align="start" sideOffset={10} className="w-[min(92vw,440px)] rounded-card border-separator p-4 shadow-pop" data-testid={`filter-panel-${s.id}`}>
            {s.id === "delivery" && <div className="space-y-1">{DELIVERY.map(([id, label]) => <Option key={id} on={value.delivery === id} onClick={() => set("delivery", id)} testId={`delivery-${id}`}>{label}</Option>)}</div>}
            {s.id === "type" && <div className="space-y-1">{TYPES.map(([id, label]) => <Option key={id} on={value.type === id} onClick={() => set("type", id)} testId={`type-${id}`}>{label}</Option>)}</div>}
            {s.id === "docs" && <div className="space-y-1">{DOCS.map(([id, label]) => <Option key={id} on={value.docs === id} onClick={() => set("docs", id)} testId={`docs-${id}`}>{label}</Option>)}</div>}
            {s.id === "dates" && <DatesPanel value={value.dates} onChange={(dt) => onChange({ ...value, dates: dt })} />}
            {s.id === "budget" && <BudgetPanel value={value.budget} cat={value.cat} onChange={(b) => onChange({ ...value, budget: b })} />}
          </PopoverContent>
        </Popover>
      ))}
    </div>
  );
}
